module.exports = __webpack_public_path__ + "static/media/LOGO NEVERLAND (HORISONTAL)-03.c5b4450c.png";